// extracted by mini-css-extract-plugin
export default {"root":"CwFsu5gr","icon":"JllRSehm","content":"GbGJZELk","title":"p6_UcGYb","description":"eRV2bPVo"};